import Link from "next/link";

const DinesLink = ({
  children,
  ...props
}: React.PropsWithChildren<React.ComponentProps<typeof Link>> & {
  legacyBehavior?: never;
}) => <Link {...props}>{children}</Link>;

export default DinesLink;
